import rootSaga from "../Sagas/";
import { combineReducers } from "@reduxjs/toolkit";
import configureStore from "./CreateStore";
import { reducer as authReducer } from "./AuthRedux";

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  auth: authReducer,
});

export const { store } = configureStore(reducers, rootSaga);

export default () => {
  const finalReducers = reducers;
  const { store: newStore, sagasManager, sagaMiddleware } = configureStore(
    finalReducers,
    rootSaga,
  );

  return { store: newStore, sagasManager, sagaMiddleware };
};
